"use strict";function insertBefore(node, referenceNode, parentNode) {
  if (node.insertInto) {
    return node.insertInto(parentNode, referenceNode);
  }
  return parentNode.insertBefore(
    node,
    referenceNode && referenceNode.startNode || referenceNode
  );
}

function insertAfter(node, referenceNode, parentNode) {
  return insertBefore(
    node,
    referenceNode && referenceNode.nextSibling,
    parentNode
  );
}

function nextSibling(node) {
  var next = node.nextSibling;
  var fragment = next && next.fragment;
  if (fragment) {
    return next === fragment.startNode ? fragment : null;
  }
  return next;
}

function firstChild(node) {
  var next = node.firstChild;
  return next && next.fragment || next;
}

function removeChild(node) {
  if (node.remove) node.remove();else
  node.parentNode.removeChild(node);
}

exports.bf_ = insertBefore;
exports.bg_ = insertAfter;
exports.cm_ = nextSibling;
exports.aA_ = firstChild;
exports.bh_ = removeChild;